const Section = (props) => {
  return (
    <div className="border-2 border-neutral-100	rounded-md p-3 xl:p-8 mb-3 xl:mb-8">
      {props.children}
    </div>
  );
};

export default Section;
